export default __webpack_public_path__ + "assets/models/230d4ab851f514e18a94cbc60bfb50b5.glb";